export const pricingTiers = [
  {
    name: 'Scale',
    description: 'Scale your integrations in multiple geographies easily',
    features: [
      { text: 'Unlimited tenants or connectors', included: true },
      { text: 'Unlimited workflows', included: true },
      { text: 'Unlimited API Calls', included: true },
      { text: 'Custom app builder with AI', included: true },
      { text: 'Dynamic field mapping', included: true },
      { text: 'Production tenants', included: true },
      { text: 'Multi-region deployment', included: true },
      { text: 'Slack / Teams onboarding', included: true },
      { text: 'Syncing & polling', included: true },
      { text: 'Option for dedicated cluster', included: true },
      { text: 'Logs Streaming via API', included: true },
      { text: 'Integration Solutioning', included: true },
      { text: 'Advanced observability', included: true }
    ],
    cta: { text: 'Talk to Sales Team', href: 'https://cal.com/cobalt/welcome-to-cobalt' }
  },
  {
    name: 'Enterprise',
    description: 'Deploy an integration layer for enterprise customers',
    features: [
      { text: 'Everything in Cloud "plus"', included: true },
      { text: 'Customer-facing workflows', included: true },
      { text: 'Deployment in your VPC', included: true },
      { text: 'AI Integration Agents', included: true },
      { text: 'Advanced uptime SLAs', included: true },
      { text: 'Priority support', included: true },
      { text: 'End-customer on-premise', included: true },
      { text: 'Red-badge engineers', included: true },
      { text: 'Whiteglove support', included: true },
      { text: 'End-customer cloud deployment', included: true },
      { text: 'SAML-based SSO', included: true }
    ],
    cta: { text: 'Talk to Sales Team', href: 'https://cal.com/cobalt/welcome-to-cobalt' }
  }
];

export const faqItems = [
  {
    question: 'Which plan is right for me—Scale or Enterprise?',
    answer: 'Scale is for emerging or mid-sized SaaS teams needing unlimited workflows and standard support. Enterprise is for larger, more complex needs, offering advanced features like multi-region deployments, higher SLAs, and dedicated clusters.'
  },
  {
    question: 'What is an "integrated app" in Cobalt?',
    answer: 'Any app you integrate from our connector catalog or build using our AI-powered custom connector is considered an "integrated app."'
  },
  {
    question: 'How does usage billing work?',
    answer: 'You pay a base platform fee for either Scale or Enterprise, then add usage-based charges based on two integration types:<ul><li>Power Integrations (flat monthly fee, unlimited users)</li><li>Long-Tail Integrations (pay per active customer until adoption justifies switching to Power)</li></ul>This ensures you only pay for what you need, with costs capped when an integration becomes widely used.'
  },
  {
    question: 'What are the deployment options for Cobalt?',
    answer: '<ul><li>Cloud (Multi-Tenant): Quick setup with minimal overhead</li><li>Private Cloud: Dedicated clusters for tighter control and security</li><li>On-Premise: Full data residency by running within your environment</li></ul>'
  },
  {
    question: 'Can I use Cobalt with my on-premise systems?',
    answer: 'Yes. We securely connect to on-premise apps via VPN or private networking. Our support team assists with configuring secure tunnels so data remains in your control.'
  },
  {
    question: 'How many workflows can I create?',
    answer: 'Both Scale and Enterprise plans include unlimited workflows at no extra charge.'
  },
  {
    question: 'What if I need an integration that isn\'t in the marketplace?',
    answer: '<ul><li>Request a Custom Connector: We can build it for you.</li><li>Build Your Own: Use our AI-powered Custom Connector Builder.</li></ul>'
  },
  {
    question: 'How do I migrate my existing integrations to Cobalt?',
    answer: 'We offer a guided process: assess current workflows, replicate or adapt them with Cobalt connectors or custom logic, test in a sandbox, and launch with minimal downtime.'
  },
  {
    question: 'Can I export my workflows?',
    answer: 'Yes. Workflow definitions can be exported for auditing or advanced customization, ensuring you retain full visibility over your integration logic.'
  },
  {
    question: 'How do I get support or additional help?',
    answer: '<ul><li>Scale: Guided onboarding and standard support.</li><li>Enterprise: Dedicated setup engineer, priority support, and direct escalation.</li><li>Specialized Needs: Engage a dedicated Integration Engineer for architecture consulting or custom development.</li></ul>'
  }
];

export const pricingData = {
  cta: {
    title: "The future of software integration is seamlessly integrated",
    description: "Be ready with cobalt's embedded integrations platform.",
    cta: {
      text: 'Get Started',
      href: '/signup',
      secondary: {
        text: 'Sign-in',
        href: '/signin'
      }
    }
  }
};